import React from "react";
import styles from "./styles.css";
import searchIcon from "./images/search-icon.svg";
import PropTypes from "prop-types";
import { highlightText } from "../../../utils/helpers/highlight-text";

const MakeModalSearchList = ({
    searchSuggestions,
    searchInput,
    handleSearchSuggestionSelect,
    shouldShowSearchIcon = true,
    emptyStateText = "No results found",
    listHeaderText = "",
    isLoading = false,
    loadingText = ""
}) => {

    const getHeaderElementText = (text = "") => {
        return (
            <li>
                <div dangerouslySetInnerHTML={{ __html: text }} />
            </li>
        );
    };

    const renderHeaderText = () => {
        if (isLoading) {
            return getHeaderElementText(loadingText);
        }
        if (searchSuggestions.length) {
            return getHeaderElementText(listHeaderText);
        } else if (searchSuggestions.length === 0) {
            return getHeaderElementText(emptyStateText);
        }
        return null;
    };

    return (
        <React.Fragment>
            <ul styleName={"styles.searchList"}>
                {renderHeaderText()}
                {searchSuggestions && !searchInput && searchSuggestions.map((option, index) => {
                    const { displayTitle } = option;
                    return (
                        <li key={index} onClick={(event) => handleSearchSuggestionSelect(option, index, event)}>
                            {shouldShowSearchIcon && <img src={searchIcon} alt=""/>}
                            <span>{displayTitle}</span>
                        </li>
                    );
                })}
                {searchSuggestions && searchInput && searchSuggestions.map((option, index) => {
                    const { displayTitle } = option;
                    return (
                        <li key={index} onClick={(event) => handleSearchSuggestionSelect(option, index, event)}>
                            {shouldShowSearchIcon && <img src={searchIcon} alt=""/>}
                            <span dangerouslySetInnerHTML={{ __html: highlightText(displayTitle, searchInput.toLowerCase()) }} />
                        </li>
                    );
                })}
            </ul>
        </React.Fragment>
    );
};

MakeModalSearchList.propTypes = {
    searchSuggestions: PropTypes.array,
    searchInput: PropTypes.string,
    handleSearchSuggestionSelect: PropTypes.func,
    shouldShowSearchIcon: PropTypes.bool,
    shouldShowEmptyState: PropTypes.bool,
    emptyStateText: PropTypes.string,
    listHeaderText: PropTypes.string,
    isLoading: PropTypes.bool,
    loadingText: PropTypes.string
};

export default MakeModalSearchList;
